/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

export const setReduxDataOnSearchScreen = (data) => ({
  type: ActionTypes.SEARCH_SCREEN_REDUX_DATA,
  searchScreenReduxObj: data,
});
export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_RECIEVED,
  payload: data,
});
export const setInterestRecievedReport = (data) => ({
  type: ActionTypes.GET_INTEREST_RECIEVED_REPORT,
  payload: data,
});

export const refreshInterestRecieved = () => ({
  type: ActionTypes.REFRESH_INTEREST_RECIEVED,
  payload: {},
});

// This action show error message for 5 sec for no contract exists
const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  // dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

// API to get Interest Recievd Reports data
export const getInterestRecievedReports = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.INTEREST_RECIEVED_REPORTS, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response?.data?.interestReceviedReportVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        return dispatch(
          setInterestRecievedReport(response?.data?.interestReceviedReportVO)
        );
      }
    })
    .catch(() => {
      dispatch(setLoading(false));
      dispatch(setInterestRecievedReport([]));
    });
};
export const clearReduxInterestRecievedSearchScreen = () => (dispatch) => {
  dispatch(setSearchInput({ errors: [] }));
  dispatch(setLoading(false));
  dispatch(setReduxDataOnSearchScreen({}));
};
export const clearReduxInterestRecievedDetailsScreen = () => (dispatch) => {
  dispatch(setLoading(false));
  dispatch(setInterestRecievedReport([]));
};
